import React from 'react';
import ReactResponsiveModal from 'react-responsive-modal';
import cx from 'classnames';
import styles from './Modal.module.scss';
import 'react-responsive-modal/styles.css';

export default function Modal(props) {
  const { children, className, title, open, value, onClose, src, closeOnEsc, innerRef, ...rest } = props;
  return (
    <ReactResponsiveModal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      center
      closeOnEsc={closeOnEsc}
      classNames={{
        overlay: styles.customOverlay,
        modal: cx(styles.customModal, className),
      }}
      {...(innerRef ? { ref: innerRef } : {})}
      {...rest}
    >
      {children}
    </ReactResponsiveModal>
  );
}
